import createReducer from 'utils/createReducer';
import { combineReducers } from 'redux';
import {
  GET_ALL_BUSINESS_SUCCESS,
  CHANGE_BUSINESS_FILTER,
  GETTING_ALL_BUSINESS,
  OPEN_BUSINESS_DETAILS,
  CLOSE_BUSINESS_DETAILS,
  SET_ACTIVE_BUSINESS_DETAILS,
  SET_BUSINESS_MENU_ITEM,
  GETTING_BUSINESS_DETAILS,
  GET_EMPLOYEE_SLOTS_SUCCESS,
  GET_EMPLOYEE_SLOTS_LOGS_SUCCESS,
  GETTING_EMPLOYEE_SLOTS_LOGS,
  GETTING_EMPLOYEE_SLOTS,
  GET_BUSINESS_DETAILS_SUCCESS,
  UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
  CREATING_EMPLOYEE_SLOT,
  GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS,
  SET_EMPLOYEE_MENU_ITEM,
  SET_EMPLOYEE_SLOTS_PAGE,
  SET_EMPLOYEE_ACTIONS_PAGE,
  SET_EMPLOYEE_LOGS_PAGE,
  OPEN_CREATE_EMPLOYEE_SLOT_MODAL,
  CLOSE_CREATE_EMPLOYEE_SLOT_MODAL,
  SET_BUSINESS_DETAIL_MENU_ITEM,
  UPDATING_BUSINESS_PACKAGE,
  OPEN_UPDATE_RENEWAL_STATUS_MODAL,
  CLOSE_UPDATE_RENEWAL_STATUS_MODAL,
  SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX,
  OPEN_UPDATE_BUSINESS_PACKAGE_MODAL,
  CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL,
  SET_SELECTED_BUSINESS_PACKAGE,
  GET_OUTLETS_SUCCESS,
  LOADING_OUTLETS,
  GET_DEVICE_LOGS_SUCCESS,
  GET_BILLING_HISTORY_SUCCESS,
  GET_FEATURE_SUBSCRIPTIONS_SUCCESS,
  GET_OUTLET_SLOTS_SUCCESS,
  GETTING_GOBIZ_LINKING,
  GET_GOBIZ_LINKING_SUCCESS,
  SET_LINKING_MENU_ITEM,
  UPDATE_OUTLET_SUBSCRIPTIONS_UI,
  LOADING_OUTLET_LOGS,
  GET_OUTLET_LOGS_SUCCESS,
  GETTING_RECURRING_PAYMENTS_DETAILS,
  GET_RECURRING_PAYMENTS_DETAILS_SUCCESS,
  CANCELLING_RECURRING_PAYMENT,
  SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
  CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION,
  GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS,
  GET_RECURRING_PAYMENT_HISTORY_SUCCESS,
} from 'state/actionTypes';

const allBusiness = createReducer(
  {},
  {
    [GET_ALL_BUSINESS_SUCCESS]: (state, { payload }) => {
      return { ...payload, activeIndex: -1 };
    },
    [SET_ACTIVE_BUSINESS_DETAILS]: (state, { payload }) => {
      const { index, businessData } = payload;
      const newBusinessData = { ...businessData };
      newBusinessData.activeIndex = index;
      return newBusinessData;
    },
  }
);

const filterInitialState = {
  startDate: null,
  endDate: null,
  status: 'all',
  searchBy: 'user_email',
  searchKeyword: '',
  invoiceNumber: '',
  statusOptions: [
    { key: 'all', value: 'all', text: 'ALL' },
    { key: 'paying', value: 'paying', text: 'Paying' },
    { key: 'expired', value: 'expired', text: 'Expired' },
    { key: 'trial', value: 'trial', text: 'Trial' },
    { key: 'mokapay', value: 'mokapay', text: 'Mokapay' },
  ],
  searchByOptions: [
    { key: 'user_email', value: 'user_email', text: 'User Email' },
    { key: 'user_name', value: 'user_name', text: 'User Name' },
    { key: 'business_email', value: 'business_email', text: 'Business Email' },
    { key: 'business_name', value: 'business_name', text: 'Business Name' },
    { key: 'phone', value: 'phone', text: 'Phone' },
    { key: 'outlet_name', value: 'outlet_name', text: 'Outlet Name' },
  ],
};

const filters = createReducer(filterInitialState, {
  [CHANGE_BUSINESS_FILTER]: (state, { payload }) => ({
    ...state,
    ...payload,
    searchKeyword: payload.searchKeyword,
  }),
});

const gettingAllBusiness = createReducer(false, {
  [GETTING_ALL_BUSINESS]: (state, { payload }) => payload,
});

const businessDetails = createReducer(false, {
  [OPEN_BUSINESS_DETAILS]: () => true,
  [CLOSE_BUSINESS_DETAILS]: () => false,
});

const menuItem = createReducer('business', {
  [SET_BUSINESS_MENU_ITEM]: (state, { payload }) => payload,
});

const gettingEmployeeSlotsLogs = createReducer(false, {
  [GETTING_EMPLOYEE_SLOTS_LOGS]: (state, { payload }) => payload,
});

const gettingEmployeeSlots = createReducer(false, {
  [GETTING_EMPLOYEE_SLOTS]: (state, { payload }) => payload,
});

const gettingBusinessDetails = createReducer(false, {
  [GETTING_BUSINESS_DETAILS]: (state, { payload }) => payload,
});

const creatingEmployeeSlot = createReducer(false, {
  [CREATING_EMPLOYEE_SLOT]: (state, { payload }) => payload,
});

const updatingEmployeeSlotIsRenewableStatus = createReducer(false, {
  [UPDATING_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS]: (state, { payload }) => payload,
});

const employeeSlots = createReducer(
  {},
  {
    [GET_EMPLOYEE_SLOTS_SUCCESS]: (state, { payload }) => payload,
  }
);

const purchasedEmployeeSlots = createReducer([], {
  [GET_PURCHASED_EMPLOYEE_SLOTS_SUCCESS]: (state, { payload }) => payload,
});

const employeeSlotsLogs = createReducer(
  {},
  {
    [GET_EMPLOYEE_SLOTS_LOGS_SUCCESS]: (state, { payload }) => payload,
  }
);

const businessDetailsData = createReducer(
  {},
  {
    [GET_BUSINESS_DETAILS_SUCCESS]: (state, { payload }) => payload,
  }
);

const employeeMenuItem = createReducer('slots', {
  [SET_EMPLOYEE_MENU_ITEM]: (state, { payload }) => payload,
});

const employeeSlotsPage = createReducer(1, {
  [SET_EMPLOYEE_SLOTS_PAGE]: (state, { payload }) => payload,
});

const employeeActionsPage = createReducer(1, {
  [SET_EMPLOYEE_ACTIONS_PAGE]: (state, { payload }) => payload,
});

const employeeLogsPage = createReducer(1, {
  [SET_EMPLOYEE_LOGS_PAGE]: (state, { payload }) => payload,
});

const createEmployeeSlotModal = createReducer(false, {
  [OPEN_CREATE_EMPLOYEE_SLOT_MODAL]: () => true,
  [CLOSE_CREATE_EMPLOYEE_SLOT_MODAL]: () => false,
});

const businessDetailMenuItem = createReducer('profile', {
  [SET_BUSINESS_DETAIL_MENU_ITEM]: (state, { payload }) => payload,
});

const updatingBusinessPackage = createReducer(false, {
  [UPDATING_BUSINESS_PACKAGE]: (state, { payload }) => payload,
});

const updateRenewalStatusModal = createReducer(false, {
  [OPEN_UPDATE_RENEWAL_STATUS_MODAL]: () => true,
  [CLOSE_UPDATE_RENEWAL_STATUS_MODAL]: () => false,
});

const selectedUpdateRenewalStatusIndex = createReducer(-1, {
  [SET_SELECTED_UPDATE_RENEWAL_STATUS_INDEX]: (state, { payload }) => payload,
});

const updateBusinessPackageModal = createReducer(false, {
  [OPEN_UPDATE_BUSINESS_PACKAGE_MODAL]: () => true,
  [CLOSE_UPDATE_BUSINESS_PACKAGE_MODAL]: () => false,
});

const selectedBusinessPackage = createReducer('', {
  [SET_SELECTED_BUSINESS_PACKAGE]: (state, { payload }) => payload,
});

const outlets = createReducer(
  {},
  {
    [GET_OUTLETS_SUCCESS]: (state, { payload }) => payload,
    [UPDATE_OUTLET_SUBSCRIPTIONS_UI]: (state, { payload }) => {
      const {
        new_date: newExpirationDate,
        outlet_ids: outletIds,
        is_active_subscription: newIsActiveSubscription,
      } = payload;
      outletIds.forEach(outletId => {
        const idx = state.data.outlets.findIndex(outlet => {
          return outlet.id === outletId;
        });
        if (newExpirationDate) {
          // eslint-disable-next-line no-param-reassign
          state.data.outlets[idx].end_date = newExpirationDate;
        }
        if (newIsActiveSubscription || newIsActiveSubscription === false) {
          // eslint-disable-next-line no-param-reassign
          state.data.outlets[
            idx
          ].is_active_subscription = newIsActiveSubscription;
        }
      });
    },
  }
);

const loadingOutlets = createReducer(false, {
  [LOADING_OUTLETS]: (state, { payload }) => payload,
});

const deviceLogs = createReducer(
  {},
  {
    [GET_DEVICE_LOGS_SUCCESS]: (state, { payload }) => payload,
  }
);

const billingHistory = createReducer(
  {},
  {
    [GET_BILLING_HISTORY_SUCCESS]: (state, { payload }) => payload,
  }
);

const featureSubscriptions = createReducer(
  {},
  {
    [GET_FEATURE_SUBSCRIPTIONS_SUCCESS]: (state, { payload }) => payload,
  }
);

const outletSlots = createReducer(
  {},
  {
    [GET_OUTLET_SLOTS_SUCCESS]: (state, { payload }) => {
      return payload;
    },
  }
);
const goBizLinking = createReducer(
  {},
  {
    [GET_GOBIZ_LINKING_SUCCESS]: (state, { payload }) => payload,
  }
);

const gettingGoBizLinking = createReducer(false, {
  [GETTING_GOBIZ_LINKING]: (state, { payload }) => payload,
});

const linkingMenuItem = createReducer('Gobiz', {
  [SET_LINKING_MENU_ITEM]: (state, { payload }) => payload,
});

const outletLogs = createReducer(
  {},
  {
    [GET_OUTLET_LOGS_SUCCESS]: (state, { payload }) => payload,
  }
);

const loadingOutletLogs = createReducer(false, {
  [LOADING_OUTLET_LOGS]: (state, { payload }) => payload,
});

const gettingRecurringPaymentsDetails = createReducer(false, {
  [GETTING_RECURRING_PAYMENTS_DETAILS]: (state, { payload }) => payload,
});

const recurringPaymentsData = createReducer(
  {},
  {
    [GET_RECURRING_PAYMENTS_DETAILS_SUCCESS]: (state, { payload }) => payload,
  }
);

const cancelRecurringPaymentConfirmation = createReducer(false, {
  [SHOW_CANCEL_RECURRING_PAYMENT_CONFIRMATION]: () => true,
  [CLOSE_CANCEL_RECURRING_PAYMENT_CONFIRMATION]: () => false,
});

const cancellingRecurringPayment = createReducer(false, {
  [CANCELLING_RECURRING_PAYMENT]: (state, { payload }) => payload,
});

const recurringPaymentHistoryData = createReducer(
  {},
  {
    [GET_RECURRING_PAYMENT_HISTORY_SUCCESS]: (state, { payload }) => payload,
  }
);

const recurringPaymentTransactionsData = createReducer(
  {},
  {
    [GET_RECURRING_PAYMENT_TRANSACTIONS_SUCCESS]: (state, { payload }) =>
      payload,
  }
);

export default combineReducers({
  allBusiness,
  gettingAllBusiness,
  filters,
  businessDetails,
  menuItem,
  gettingEmployeeSlotsLogs,
  gettingEmployeeSlots,
  gettingBusinessDetails,
  employeeSlots,
  employeeSlotsLogs,
  creatingEmployeeSlot,
  updatingEmployeeSlotIsRenewableStatus,
  businessDetailsData,
  purchasedEmployeeSlots,
  employeeMenuItem,
  employeeSlotsPage,
  employeeActionsPage,
  employeeLogsPage,
  createEmployeeSlotModal,
  businessDetailMenuItem,
  updatingBusinessPackage,
  updateRenewalStatusModal,
  selectedUpdateRenewalStatusIndex,
  updateBusinessPackageModal,
  selectedBusinessPackage,
  outlets,
  loadingOutlets,
  deviceLogs,
  billingHistory,
  featureSubscriptions,
  outletSlots,
  goBizLinking,
  gettingGoBizLinking,
  linkingMenuItem,
  outletLogs,
  loadingOutletLogs,
  gettingRecurringPaymentsDetails,
  recurringPaymentsData,
  cancelRecurringPaymentConfirmation,
  cancellingRecurringPayment,
  recurringPaymentHistoryData,
  recurringPaymentTransactionsData,
});
